import * as operateComponentAPI from '../../../../api/nativeComponentAPI'
import * as nativeComponentListener from '../../../../api/nativeComponentListener'
import NativeComponent from "../NativeComponent";


const nativeComponentAbility = NativeComponent.nativeComponentAbility

/**
 * mintegral SDK 所有可视原生组件的基类
 * @constructor
 * @extends NativeComponent
 * @param action 创建原生组件对应的api
 * @param options 构造参数
 */
export default class VisibleComponent extends NativeComponent {
    constructor (action, options={}) {
        super(action, options)

        this.bindVisibleComponentEvent()
    }

    bindVisibleComponentEvent() {
        this.onRectChanged((data)=>{
            console.log('Component onRectChanged ', data)
        })

        this.onRemoveSelf((data)=>{
            console.log('Component onRemoveSelf ', data)
        })

        this.onAppend((data)=>{
            console.log('Component onAppend ', data)
        })

        this.onAppendTo((data)=>{
            console.log('Component onAppendTo ', data)
        })

        this.onBringToFront((data)=>{
            console.log('Component onBringToFront ', data)
        })

        this.onHide((data)=>{
            console.log('Component onHide ', data)
        })

        this.onShow((data)=>{
            console.log('Component onShow ', data)
        })

        this.onBgColorChanged((data)=>{
            console.log('Component onBgColorChanged ', data)
        })

        this.onAlphaChanged((data)=>{
            console.log('Component onAlphaChanged ', data)
        })

        this.onScaleChanged((data)=>{
            console.log('Component onScaleChanged ', data)
        })

        this.onInsertAbove((data)=>{
            console.log('Component onInsertAbove ', data)
        })

        this.onInsertBelow((data)=>{
            console.log('Component onInsertBelow ', data)
        })

        this.onClicked((data)=>{
            console.log('Component onClicked ', data)
        })
    }


    @nativeComponentAbility
    testCommon(params) {
        return new Promise(resolve => {
            resolve()
        })
    }


    //*****************************************--方法--******************************************//

    /**
     *
     * @param params
     * @returns {*|Promise<any>}
     */
    /*@nativeComponentAbility
    getViewInfo(params) {
        const _params = this.getInvokeParams(params)
        return operateComponentAPI.getViewInfo(_params)
    }*/

    /*@nativeComponentAbility
    setViewInfo(params) {
        const _params = this.getInvokeParams(params)
        return operateComponentAPI.setViewInfo(_params)
    }*/


    /**
     * 设置视图定位宽高
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    setRect(params) {
        //console.log('设置视图定位宽高:', params)
        const _params = this.getInvokeParams({rect:params})
        return operateComponentAPI.setViewRect(_params)
    }


    /**
     * 移动当前组件到父视图的顶部
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    toFront(params) {
        const _params = this.getInvokeParams(params)
        return operateComponentAPI.bringViewToFront(_params)
    }

    /**
     * 在当前组件上添加其他组件
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    append(sub, rect) {
        /*return new Promise(resolve => {
            sub.onCreateSuccess(()=>{
                //console.warn("Append---",this,sub,rect)
                const params = {
                    id: sub.id,
                    rect // : {"top":10,"bottom":20,"left":20,"right":30,"width":320,"height":480}
                }
                const _params = this.getInvokeParams(params)
                let ret =  operateComponentAPI.appendSubView(_params)
                resolve(ret)
            })
        })*/
        sub.onCreateSuccess(()=>{
            //console.warn("Append---",this,sub,rect)
            const params = {
                id: sub.id,
                rect // : {"top":10,"bottom":20,"left":20,"right":30,"width":320,"height":480}
            }
            const _params = this.getInvokeParams(params)
            let ret =  operateComponentAPI.appendSubView(_params)
            //resolve(ret)
        })
    }

    /**
     * 将当前组件添加到指定组件上
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    appendTo(target, rect) {
        //console.log('appendTo===>', this.id, target)
        if(target instanceof VisibleComponent){
            return target.whenCreateSuccess().then(()=>{
                const params = {
                    id: target.id,
                    rect // : {"top":10,"bottom":20,"left":20,"right":30,"width":320,"height":480}
                }
                const _params = this.getInvokeParams(params)
                return operateComponentAPI.appendViewTo(_params)
            })
        // 如果是appendTo到rootView到情况
        }else if(target.id){
            const params = {
                id: target.id,
                rect
            }
            const _params = this.getInvokeParams(params)
            return operateComponentAPI.appendViewTo(_params)
        }

    }

    /**
     * 从父视图移除自身
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    removeSelf(params) {
        const _params = this.getInvokeParams(params)
        return operateComponentAPI.removeFromSuperView(_params)
    }

    /**
     * 隐藏组件
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    hide(params) {
        const _params = this.getInvokeParams(params)
        return operateComponentAPI.hideView(_params)
    }

    /**
     * 显示组件
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    show(params) {
        const _params = this.getInvokeParams(params)
        return operateComponentAPI.showView(_params)
    }

    /**
     * 设置背景
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    setBG(params) {
        let _params = this.getInvokeParams(params)
        return operateComponentAPI.setViewBgColor(_params)
    }

    /**
     * 设置透明度
     * @param alpha  透明度值：0 ～ 1.0
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    setAlpha(alpha) {
        const _params = this.getInvokeParams({alpha})
        return operateComponentAPI.setViewAlpha(_params)
    }

    /**
     * 设置缩放
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    setScale(params) {
        const _params = this.getInvokeParams(params)
        return operateComponentAPI.setViewScale(_params)
    }

    /**
     * 插入到target组件层级的上方
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    insertAboveTo(target, rect){
        const _params = this.getInvokeParams({
            sourceComponentId: this.id,
            targetComponentId: target.id,
            rect
        })
        return operateComponentAPI.insertAboveTo(_params)
    }

    /**
     * 插入到target组件层级的下方
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    insertBelowTo(target, rect){
        const _params = this.getInvokeParams({
            sourceComponentId: this.id,
            targetComponentId: target.id,
            rect
        })
        return operateComponentAPI.insertBelowTo(_params)
    }


    //*****************************************--事件--******************************************//


    /**
     * 设置视图时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onRectChanged(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onViewRectChanged(this.getId(), cb)
    }

    /**
     * 被从父视图移除时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onRemoveSelf(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onRemoveFromView(this.getId(), cb)
    }

    /**
     * 在当前视图上添加其他视图时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onAppend(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onAppendView(this.getId(), cb)
    }

    /**
     * 将当前视图添加到指定视图上时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onAppendTo(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onAppendViewTo(this.getId(), cb)
    }

    /**
     * 当前视图层级被置顶时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onBringToFront(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onBringViewToFront(this.getId(), cb)
    }

    /**
     * 隐藏组件时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onHide(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onHideView(this.getId(), cb)
    }

    /**
     * 显示组件时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onShow(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onShowView(this.getId(), cb)
    }

    /**
     * 背景颜色改变时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onBgColorChanged(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onViewBgColorChanged(this.getId(), cb)
    }

    /**
     * 透明度改变时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onAlphaChanged(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onViewAlphaChanged(this.getId(), cb)
    }

    /**
     * 组件缩放改变时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onScaleChanged(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onViewScaleChanged(this.getId(), cb)
    }


    /**
     * 将组件添加到目标组件的上层时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onInsertAbove(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onInsertViewAbove(this.getId(), cb)
    }

    /**
     * 将组件添加到目标组件的下层时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onInsertBelow(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onInsertViewBelow(this.getId(), cb)
    }

    /**
     * 组件被点击时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onClicked(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onClicked(this.getId(), cb)
    }

    /**
     * 组件被双击时触发（SDK暂未实现）
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onDoubleClicked(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onDoubleClicked(this.getId(), cb)
    }


}
